export default {"src":"/_next/static/media/challenge-monthly-badge.ac8e5d4d.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};